import { render, staticRenderFns } from "./Report-services.vue?vue&type=template&id=f0f898d2&scoped=true"
import script from "./Report-services.vue?vue&type=script&lang=js"
export * from "./Report-services.vue?vue&type=script&lang=js"
import style0 from "./Report-services.vue?vue&type=style&index=0&id=f0f898d2&prod&scoped=true&lang=css"
import style1 from "./Report-services.vue?vue&type=style&index=1&id=f0f898d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f898d2",
  null
  
)

export default component.exports